export default "__VITE_ASSET__I0JtH2Yd__"